document.addEventListener('DOMContentLoaded', () => {

    // ── Elementy ──────────────────────────────────────────────
    const hamburger  = document.querySelector('.site-header__hamburger');
    const mobileNav  = document.querySelector('.mobile-nav');
    const backdrop   = document.querySelector('.mobile-nav__backdrop');
    const closeBtn   = document.querySelector('.mobile-nav__close');
    const panel      = document.querySelector('.mobile-nav__panel');

    // Mobile-nav handling tylko jeśli oba elementy istnieją. NIE używamy early `return`
    // bo przerwałoby cały DOMContentLoaded callback i zablokowało secondary nav handlery
    // (które są niezależne i mogą istnieć nawet gdy mobile-nav nie ma — np. w trybie
    // synced header, gdzie nasz natywny mobile-nav nie jest renderowany).
    if (hamburger && mobileNav) {

    // ── Otwieranie menu ───────────────────────────────────────
    function openMenu() {
        hamburger.setAttribute('aria-expanded', 'true');
        hamburger.setAttribute('aria-label', 'Zamknij menu');
        hamburger.classList.add('is-open');

        mobileNav.classList.add('mobile-nav--open');
        mobileNav.setAttribute('aria-hidden', 'false');

        document.body.classList.add('menu-open');

        // Focus trap — przenieś focus na pierwszy link panelu
        const firstFocusable = panel?.querySelector('a, button');
        if (firstFocusable) setTimeout(() => firstFocusable.focus(), 200);
    }

    // ── Zamykanie menu ────────────────────────────────────────
    function closeMenu() {
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.setAttribute('aria-label', 'Otwórz menu');
        hamburger.classList.remove('is-open');

        mobileNav.classList.remove('mobile-nav--open');
        mobileNav.setAttribute('aria-hidden', 'true');

        document.body.classList.remove('menu-open');

        // Zwiń wszystkie otwarte podmenu
        document.querySelectorAll('.mobile-nav .sub-menu--open').forEach(sub => {
            sub.classList.remove('sub-menu--open');
        });
        document.querySelectorAll('.mobile-nav .menu-item.is-expanded').forEach(item => {
            item.classList.remove('is-expanded');
        });

        // Przywróć focus na hamburger
        hamburger.focus();
    }

    // ── Eventy ────────────────────────────────────────────────
    hamburger.addEventListener('click', openMenu);

    if (backdrop) backdrop.addEventListener('click', closeMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    // ESC zamyka menu
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && mobileNav.classList.contains('mobile-nav--open')) {
            closeMenu();
        }
    });

    // ── Podmenu (toggle) ──────────────────────────────────────
    document.querySelectorAll('.mobile-nav__list .menu-item-has-children').forEach(item => {
        const link   = item.querySelector(':scope > a');
        const toggle = link?.querySelector('.menu-item-open-submenu');
        const sub    = item.querySelector(':scope > .sub-menu');

        if (!toggle || !sub) return;

        link.addEventListener('click', (e) => {
            // Klik w obszar chevronu — toggle podmenu, nie nawiguj
            if (e.target.closest('.menu-item-open-submenu')) {
                e.preventDefault();
                e.stopPropagation();

                const isExpanded = item.classList.contains('is-expanded');

                // Zwiń wszystkie inne podmenu na tym samym poziomie
                item.closest('ul')?.querySelectorAll(':scope > .menu-item.is-expanded').forEach(sibling => {
                    if (sibling !== item) {
                        sibling.classList.remove('is-expanded');
                        sibling.querySelector(':scope > .sub-menu')?.classList.remove('sub-menu--open');
                    }
                });

                item.classList.toggle('is-expanded', !isExpanded);
                sub.classList.toggle('sub-menu--open', !isExpanded);
            }
        });
    });

    // ── Zamknij po kliknięciu zwykłego linku ─────────────────
    document.querySelectorAll('.mobile-nav__list a').forEach(link => {
        link.addEventListener('click', (e) => {
            if (e.target.closest('.menu-item-open-submenu')) return;
            closeMenu();
        });
    });

    // ── Focus trap w panelu (Tab / Shift+Tab) ─────────────────
    if (panel) {
        panel.addEventListener('keydown', (e) => {
            if (e.key !== 'Tab') return;
            if (!mobileNav.classList.contains('mobile-nav--open')) return;

            const focusable = Array.from(
                panel.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')
            ).filter(el => el.offsetParent !== null);

            if (focusable.length === 0) return;

            const first = focusable[0];
            const last  = focusable[focusable.length - 1];

            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        });
    }

    } // koniec if (hamburger && mobileNav)


    document.querySelectorAll('.secondary-nav__list .menu-item-has-children').forEach(item => {
        const link    = item.querySelector(':scope > a.secondary-nav__link');
        const chevron = link?.querySelector('.secondary-nav__chevron');

        if (!chevron) return;

        chevron.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const isOpen = item.classList.contains('is-open');

            item.closest('ul')?.querySelectorAll(':scope > .menu-item.is-open').forEach(sibling => {
                if (sibling !== item) sibling.classList.remove('is-open');
            });

            item.classList.toggle('is-open', !isOpen);
        });
    });

    document.addEventListener('click', (e) => {
        if (e.target.closest('.secondary-nav')) return;
        document.querySelectorAll('.secondary-nav__list .menu-item.is-open')
            .forEach(item => item.classList.remove('is-open'));
    });

    const secToggle   = document.querySelector('.secondary-nav__mobile-toggle');
    const secDrawer   = document.querySelector('.secondary-mobile-nav');
    const secBackdrop = document.querySelector('.secondary-mobile-nav__backdrop');
    const secClose    = document.querySelector('.secondary-mobile-nav__close');
    const secPanel    = document.querySelector('.secondary-mobile-nav__panel');

    if (secToggle && secDrawer) {

        function openSecDrawer() {
            secToggle.setAttribute('aria-expanded', 'true');
            secDrawer.classList.add('secondary-mobile-nav--open');
            secDrawer.setAttribute('aria-hidden', 'false');
            document.body.classList.add('menu-open');

            const firstFocusable = secPanel?.querySelector('a, button');
            if (firstFocusable) setTimeout(() => firstFocusable.focus(), 200);
        }

        function closeSecDrawer() {
            secToggle.setAttribute('aria-expanded', 'false');
            secDrawer.classList.remove('secondary-mobile-nav--open');
            secDrawer.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('menu-open');

            secDrawer.querySelectorAll('.sub-menu--open').forEach(s => s.classList.remove('sub-menu--open'));
            secDrawer.querySelectorAll('.menu-item.is-expanded').forEach(i => i.classList.remove('is-expanded'));

            secToggle.focus();
        }

        secToggle.addEventListener('click', openSecDrawer);
        if (secBackdrop) secBackdrop.addEventListener('click', closeSecDrawer);
        if (secClose) secClose.addEventListener('click', closeSecDrawer);

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && secDrawer.classList.contains('secondary-mobile-nav--open')) {
                closeSecDrawer();
            }
        });

        secDrawer.querySelectorAll('.menu-item-has-children').forEach(item => {
            const link    = item.querySelector(':scope > a.secondary-mobile-nav__link');
            const chevron = link?.querySelector('.secondary-mobile-nav__chevron');
            const sub     = item.querySelector(':scope > .sub-menu');

            if (!chevron || !sub) return;

            link.addEventListener('click', (e) => {
                if (!e.target.closest('.secondary-mobile-nav__chevron')) return;
                e.preventDefault();
                e.stopPropagation();

                const isExpanded = item.classList.contains('is-expanded');

                item.closest('ul')?.querySelectorAll(':scope > .menu-item.is-expanded').forEach(sibling => {
                    if (sibling !== item) {
                        sibling.classList.remove('is-expanded');
                        sibling.querySelector(':scope > .sub-menu')?.classList.remove('sub-menu--open');
                    }
                });

                item.classList.toggle('is-expanded', !isExpanded);
                sub.classList.toggle('sub-menu--open', !isExpanded);
            });
        });

        secDrawer.querySelectorAll('.secondary-mobile-nav__link').forEach(link => {
            link.addEventListener('click', (e) => {
                if (e.target.closest('.secondary-mobile-nav__chevron')) return;
                closeSecDrawer();
            });
        });

        if (secPanel) {
            secPanel.addEventListener('keydown', (e) => {
                if (e.key !== 'Tab') return;
                if (!secDrawer.classList.contains('secondary-mobile-nav--open')) return;

                const focusable = Array.from(
                    secPanel.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')
                ).filter(el => el.offsetParent !== null);
                if (focusable.length === 0) return;

                const first = focusable[0];
                const last  = focusable[focusable.length - 1];

                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            });
        }
    }

    const archiveFilters = document.querySelector('.product-archive__filters');
    if (archiveFilters) {
        archiveFilters.querySelectorAll('.product-archive__checkbox').forEach(checkbox => {
            checkbox.addEventListener('change', () => archiveFilters.submit());
        });
    }

    document.querySelectorAll('[data-hero-slider]').forEach(root => {
        const track  = root.querySelector('[data-slider-track]');
        const slides = track ? Array.from(track.querySelectorAll('.hero__slide')) : [];
        const dots   = Array.from(root.querySelectorAll('[data-slider-dot]'));
        const prev   = root.querySelector('[data-slider-prev]');
        const next   = root.querySelector('[data-slider-next]');

        if (slides.length < 2) return;

        const autoplayMs = parseInt(root.dataset.autoplay, 10) || 5000;
        let current = slides.findIndex(s => s.classList.contains('is-active'));
        if (current < 0) current = 0;
        let timer = null;

        function durationFor(index) {
            const raw = slides[index]?.dataset.slideDuration;
            const perSlide = parseInt(raw, 10);
            return Number.isFinite(perSlide) && perSlide > 0 ? perSlide : autoplayMs;
        }

        function go(nextIndex) {
            const target = (nextIndex + slides.length) % slides.length;
            if (target === current) return;

            slides[current].classList.remove('is-active');
            slides[current].setAttribute('aria-hidden', 'true');
            slides[target].classList.add('is-active');
            slides[target].setAttribute('aria-hidden', 'false');

            if (dots.length) {
                dots[current]?.classList.remove('is-active');
                dots[current]?.setAttribute('aria-selected', 'false');
                dots[target]?.classList.add('is-active');
                dots[target]?.setAttribute('aria-selected', 'true');
            }

            current = target;
        }

        function start() {
            stop();
            timer = setTimeout(function tick() {
                go(current + 1);
                timer = setTimeout(tick, durationFor(current));
            }, durationFor(current));
        }

        function stop() {
            if (timer) { clearTimeout(timer); timer = null; }
        }

        prev?.addEventListener('click', () => { go(current - 1); start(); });
        next?.addEventListener('click', () => { go(current + 1); start(); });
        dots.forEach((dot, i) => dot.addEventListener('click', () => { go(i); start(); }));

        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
        root.addEventListener('focusin', stop);
        root.addEventListener('focusout', start);

        document.addEventListener('visibilitychange', () => {
            document.hidden ? stop() : start();
        });

        start();
    });

});
